import { ClusterLookupTable, SystemLookup } from "@graylog/server-api";
import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
import PaginationURL from "util/PaginationURL";
import deserializeLookupTables from "components/lookup-tables/lookup-table-list/utils";
import deserializeCaches from "components/lookup-tables/cache-list/utils";
import deserializeDataAdapters from "components/lookup-tables/adapter-list/utils";
const _url = (path) => qualifyUrl(`/system/lookup/${path}`);
export const fetchAllLookupTables = async (resolve = false) => SystemLookup.tables(void 0, 1, 0, void 0, void 0, resolve).then((response) => response.lookup_tables);
export const deleteLookupTable = async (tableId) => SystemLookup.removeTable(tableId);
export const fetchErrors = async ({
  lutNames = void 0,
  cacheNames = void 0,
  adapterNames = void 0
}) => {
  const request = {};
  if (lutNames) request.tables = lutNames;
  if (cacheNames) request.caches = cacheNames;
  if (adapterNames) request.data_adapters = adapterNames;
  return fetch("POST", _url("errorstates"), request);
};
export const fetchPaginatedLookupTables = async (searchParams) => {
  const { page, pageSize, query, sort } = searchParams;
  const sortField = sort == null ? void 0 : sort.attributeId;
  const sortOrder = sort == null ? void 0 : sort.direction;
  const url = _url(
    PaginationURL("tables", page, pageSize, query, { resolve: true, sort: sortField, order: sortOrder })
  );
  return fetch("GET", url).then(deserializeLookupTables);
};
export const fetchLookupTable = async (idOrName) => SystemLookup.get(idOrName, true);
export const createLookupTable = async (payload) => fetch("POST", _url("tables"), payload);
export const updateLookupTable = async (payload) => fetch("PUT", _url(`tables/${payload.id}`), payload);
export const validateLookupTable = async (table) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
  return SystemLookup.validateTable({
    ...table,
    id: (_a = table.id) != null ? _a : null,
    _scope: (_b = table._scope) != null ? _b : null,
    content_pack: (_c = table.content_pack) != null ? _c : null,
    title: (_d = table.title) != null ? _d : "",
    description: (_e = table.description) != null ? _e : "",
    name: (_f = table.name) != null ? _f : "",
    cache_id: (_g = table.cache_id) != null ? _g : "",
    data_adapter_id: (_h = table.data_adapter_id) != null ? _h : "",
    default_single_value: (_i = table.default_single_value) != null ? _i : "",
    default_single_value_type: (_j = table.default_single_value_type) != null ? _j : "NULL",
    default_multi_value: (_k = table.default_multi_value) != null ? _k : "",
    default_multi_value_type: (_l = table.default_multi_value_type) != null ? _l : "NULL"
  });
};
export const purgeLookupTableKey = async ({ table, key }) => ClusterLookupTable.performPurge(table.id, key);
export const purgeAllLookupTableKey = async (table) => ClusterLookupTable.performPurge(table.id);
export const testLookupTableKey = async ({ tableName, key }) => SystemLookup.performLookup(tableName, key);
export const fetchLookupPreview = async (idOrName, size) => fetch("GET", qualifyUrl(`/system/lookup/tables/preview/${idOrName}?size=${size}`));
export const fetchPaginatedCaches = async (searchParams) => {
  const { page, pageSize, query, sort } = searchParams;
  const sortField = sort == null ? void 0 : sort.attributeId;
  const sortOrder = sort == null ? void 0 : sort.direction;
  const url = _url(PaginationURL("caches", page, pageSize, query, { sort: sortField, order: sortOrder }));
  return fetch("GET", url).then(deserializeCaches);
};
export const fetchCache = async (idOrName) => SystemLookup.getCache(idOrName);
export const fetchCacheTypes = async () => SystemLookup.availableCacheTypes();
export const validateCache = async (cache) => fetch("POST", _url("caches/validate"), cache);
export const createCache = async (payload) => fetch("POST", _url("caches"), payload);
export const updateCache = async (payload) => fetch("PUT", _url(`caches/${payload.id}`), payload);
export const deleteCache = async (cacheId) => SystemLookup.deleteCache(cacheId);
export const fetchPaginatedDataAdapters = async (searchParams) => {
  const { page, pageSize, query, sort } = searchParams;
  const sortField = sort == null ? void 0 : sort.attributeId;
  const sortOrder = sort == null ? void 0 : sort.direction;
  const url = _url(PaginationURL("adapters", page, pageSize, query, { sort: sortField, order: sortOrder }));
  return fetch("GET", url).then(deserializeDataAdapters);
};
export const fetchDataAdapter = async (idOrName) => SystemLookup.getAdapter(idOrName);
export const fetchDataAdapterTypes = async () => SystemLookup.availableAdapterTypes();
export const createDataAdapter = async (payload) => fetch("POST", _url("adapters"), payload);
export const updateDataAdapter = async (payload) => fetch("PUT", _url(`adapters/${payload.id}`), payload);
export const validateDataAdapter = async (adapter) => fetch("POST", _url("adapters/validate"), adapter);
export const deleteDataAdapter = async (adapterId) => SystemLookup.deleteAdapter(adapterId);
export const lookupDataAdapter = async (adapterName, key) => fetch("GET", _url(`adapters/${adapterName}/query?key=${encodeURIComponent(key)}`));
